import Style from "./style"

const FooterPage = ({ children }) => {

    return (
        <Style.Wrapper>

            <div>{children}</div>

            <Style.Footer>
                <h2>(주)프리플랍</h2>
                <p>대표자명 | <span>신선호</span></p>
                <p>사업자등록번호 | <span>536-86-03515</span></p>
                <p>사업장 주소 | <span>서울특별시 영등포구 양평로14길 4 4층</span></p>
                <p>통신판매업신고번호 | <span></span></p>
            </Style.Footer>

        </Style.Wrapper>
    )
}

export default FooterPage